import * as React from "react"
import { SaBoxes2 } from "./saBoxes2"
// @ts-ignore
import { saHomeBoxesSection } from './saBoxes2.module.scss'
import { saInterfacesBoxes2 } from "../saTypes"



export const SaBoxes2Container: React.FC<saInterfacesBoxes2> = ({ ...props }) =>{

    return (
      <section id={'saHomeBoxesSection'}
               className={saHomeBoxesSection}
      >
        <SaBoxes2 {...props} />

      </section>
    )

}
